import {canBold, canItalics, canStrikeThrough, canUnderline} from './commands/format.js';
import {canInsertTopLevelBlockSelectable} from './commands/topLevel.js';
import {canAddKeyNotation} from "./commands/insertKeyNotation.js";
import {selectedTypes} from "./state.js";
import {canAddTable} from "./commands/addTable.js";
import {canAddImage} from "./commands/images.js";
import {canAddLink} from './commands/links.js';
import {canAddList} from './commands/addList.js';
import {canInsertEmoji} from "./commands/insertEmoji.js";

export function availableCommands(view) {
  return {
    canBold: canBold(view),
    canItalics: canItalics(view),
    canUnderline: canUnderline(view),
    canStrikeThrough: canStrikeThrough(view),
    canList: canAddList(view),
    canBlockQuote: canInsertTopLevelBlockSelectable(view),
    canLink: canAddLink(view),
    canImage: canAddImage(view),
    canCode: canInsertTopLevelBlockSelectable(view),
    canTable: canAddTable(view),
    canKey: canAddKeyNotation(view),
    canIndent: true,
    debug: selectedTypes(view.state),
    canEmoji: canInsertEmoji(view.state),
  };
}
